import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import StrategyDetailStore from '@src/pages/strategy-detail/store';
import Page from '../../components/page';
import InnerWrap from '../inner-wrap';
import Link from '@src/components/link';
import cx from 'classnames';
import DateUtil from '@src/utils/date-util';

const styles = require('./index.less');

const StrategyDetail = () => {
  const store = useStore(() => new StrategyDetailStore());
  // 部分内容只有 publishedAt / publish_at_show, 缺失时不能直接算时间, 否则出现 NaN/NaN/NaN
  const publishedAt = store.detailData?.published_at_show || store.detailData?.publish_at_show || store.detailData?.publishedAt;

  return (
    <Page className={styles.root}>
      <InnerWrap store={store.innerWrapStore}>
        <div className={styles.detailCenter}>
          <div className={styles.detailHead}>
            <div className={styles.title}>{store.detailData.title}</div>
            <div className={styles.subTitle}>{publishedAt ? DateUtil.formatDate(new Date(publishedAt * 1000), 'YYYY/MM/dd hh:mm:ss') : ''}</div>
          </div>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: store.detailData.content || '暂无内容~' }} />
          <div className={styles.detailAction}>
            <div>
              <Link className={cx(styles.detailBtn, styles.detailPrev, store.prevData.title && styles.has)} onClick={() => store.gotoDetail(store.prevData)}>
                {store.prevData.title || '没有了'}
              </Link>
            </div>
            <div>
              <Link className={cx(styles.detailBtn, styles.detailNext, store.nextData.title && styles.has)} onClick={() => store.gotoDetail(store.nextData)}>
                {store.nextData.title || '没有了'}
              </Link>
            </div>
          </div>
        </div>
      </InnerWrap>
    </Page>
  );
};

export default observer(StrategyDetail);
